<template lang="pug">
    v-container(grid-list-md v-if="content" )
        f-dialog-confirm(v-model="dialog" :message="message" :events="events"
            v-on:reinquiry="doReinquiry" v-on:dialog="dialog = $event" )
        v-layout(wrap)
            v-flex(lg6 md6 xs12)
                v-text-field(dense v-model="source" label="No. Rekening Sumber" readonly)
                    template(v-slot:prepend)
                        v-icon(color="warning") mdi-credit-card-multiple-outline
            v-flex(lg5 md5 xs12)
                v-text-field(dense v-model="content.summary.productDescription.toUpperCase() + ' (' + taxType + ')'" label="Jenis Transaksi" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg6 md6 xs12 v-if="content.note")
                v-text-field(dense v-model="content.note" label="Berita" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-note-text-outline
            v-flex(lg5 md5 xs12 v-if="content.customerRef")
                v-text-field(dense v-model="content.customerRef" label="No. Dokumen" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-file-document-outline
            v-flex(lg3 md3 xs12 )
                v-text-field(dense v-model="customerId" label="Kode Billing" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg2 md2 xs12 v-if="transaction")
                v-text-field(dense v-model="transaction.info.ntpn" label="NTPN" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg2 md2 xs12 v-if="reinquiry && !content.info.ntpn")
                div(justify-center style="text-align: center;" class="ma-2 menu-btn")
                    v-btn(class="primary mx-1" @click="dialog = true") Reinquiry
                        v-icon mdi-file-sync
            v-layout(wrap v-if="taxType == 'DJP'")
                v-flex(lg5 md5 xs12)
                    v-text-field(dense v-model="content.info.namaWajibPajak" label="Nama Wajib Pajak" readonly)
                        template(v-slot:prepend)
                            v-icon(color="primary") mdi-checkbox-marked-outline
                v-flex(lg3 md3 xs12 )
                    v-text-field(dense v-model="content.info.npwp" label="NPWP" readonly)
                        template(v-slot:prepend)
                            v-icon(color="primary") mdi-checkbox-marked-outline
                v-flex(lg8 md8 xs12 )
                    v-textarea(dense outlined v-model="content.info.alamatWajibPajak" label="Alamat Wajib Pajak" readonly rows="2")
                        template(v-slot:prepend)
                            v-icon(color="primary") mdi-map-marker
                v-flex(lg12 md12 xs12)
                    v-layout(wrap)
                        v-flex(lg2 md2 xs12)
                            v-text-field(dense v-model="content.info.akun" label="Mata Anggaran" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg2 md2 xs12 )
                            v-text-field(dense v-model="content.info.kodeJenisSetoran" label="Jenis Setoran" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg2 md2 xs12 )
                            v-text-field(dense v-model="content.info.masaPajak" label="Masa Pajak" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-calendar
                        v-flex(lg3 md3 xs12 v-if="content.info.nop")
                            v-text-field(dense v-model="content.info.nop" label="No. Objek Pajak" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg3 md3 xs12 v-if="content.info.noSk")
                            v-text-field(dense v-model="content.info.noSk" label="No. Ketetapan" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
            v-layout(wrap v-if="taxType == 'DJBC'")
                v-flex(lg3 md3 xs12 )
                    v-text-field(dense v-model="content.info.idWajibPajak" label="Id Wajib Pajak" readonly)
                        template(v-slot:prepend)
                            v-icon(color="primary") mdi-checkbox-marked-outline
                v-flex(lg5 md5 xs12 )
                    v-text-field(dense v-model="content.info.namaWajibPajak" label="Nama Wajib Pajak" readonly)
                        template(v-slot:prepend)
                            v-icon(color="primary") mdi-checkbox-marked-outline
                v-flex(lg12 md12 xs12)
                    v-layout(wrap)
                        v-flex(lg2 md2 xs12 )
                            v-text-field(dense v-model="content.info.jenisDokumen" label="Jenis Dokumen" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg3 md3 xs12 )
                            v-text-field(dense v-model="content.info.nomorDokumen" label="No Dokumen" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg2 md2 xs12 )
                            v-text-field(dense v-model="content.info.tanggalDokumen" label="Tanggal Dokumen" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-calendar
                        v-flex(lg2 md2 xs12 )
                            v-text-field(dense v-model="content.info.kppbc" label="Kode KPPBC" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
            v-layout(wrap v-if="taxType == 'DJA'")
                v-flex(lg3 md3 xs12 )
                    v-text-field(dense v-model="content.references[0]" label="Id Wajib Pajak" readonly)
                        template(v-slot:prepend)
                            v-icon(color="primary") mdi-checkbox-marked-outline
                v-flex(lg5 md5 xs12 )
                    v-text-field(dense v-model="content.info.namaWajibPajak" label="Nama Wajib Pajak" readonly)
                        template(v-slot:prepend)
                            v-icon(color="primary") mdi-checkbox-marked-outline
                v-flex(lg12 md12 xs12)
                    v-layout(wrap)
                        v-flex(lg2 md2 xs12 )
                            v-text-field(dense v-model="content.info.kl" label="Kementerian / Lembaga" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg2 md2 xs12 )
                            v-text-field(dense v-model="content.info.unitEselonI" label="Unit Eselon I" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg2 md2 xs12 )
                            v-text-field(dense v-model="content.info.kodeSatker" label="Satuan Kerja" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
            
            v-flex(lg12 md12 xs12)
                v-layout(wrap)
                    v-flex(lg3 md3 xs12)
                        f-decimalbox(v-model="amount" label="Nominal" readonly :template="true")
                    v-flex(lg3 md3 xs12 v-if="penalty")
                        f-decimalbox(v-model="penalty" label="Denda" readonly :template="true")
                    v-flex(lg2 md2 xs12)
                        f-decimalbox(v-model="fee" label="Biaya Admin" readonly :template="true")
                    v-flex(lg3 md3 xs12)
                        f-decimalbox(v-model="total" label="Total" readonly :template="true")
        div(justify-center style="text-align: center;" class="ma-2 menu-btn" v-if="reinquiry && !content.info.ntpn")
            v-btn(class="mx-1" @click="dialog = true") Reinquiry
                v-icon mdi-file-sync
</template>
<script>
export default {
    name: "FPaymentMpnContent",
    props: ["content", "request", "transaction", "reinquiry"],
    computed: {
        source() {
            return this.$options.filters.accountformat(this.content.source)+ " - " + this.content.sourceName;
        },
        customerId(){
            return this.content.references.join(" ");
        },
        taxType(){
            return (this.customerId[0] >= 0 && this.customerId[0] <= 3) ? "DJP" :
            (this.customerId[0] >= 4 && this.customerId[0] <= 6) ? "DJBC" :
            (this.customerId[0] >= 7 && this.customerId[0] <= 9) ? "DJA" : "";
        },
        penalty(){
            if (this.content.bills && this.content.bills.length > 0) {
                let pen = this.content.bills.map(m => (m.otherInfo && m.otherInfo.penalty) ? m.otherInfo.penalty : 0).reduce((a,b) => a + b);
                return pen > 0 ? pen : null;
            }else{
                return null;
            }
        },
        amount(){
            return this.penalty ? (Number(this.content.summary.amount) - Number(this.penalty)) : this.content.summary.amount;
        },
        fee(){
            return this.content.summary.feeSourceAccount ? 0 : this.content.summary.fee;
        },
        total(){
            return this.content.summary.feeSourceAccount ? this.content.summary.amount : this.content.summary.totalAmount;
        },
    },
    data() {
        return {
            dialog: false,
            message: "Apakah anda yakin akan melakukan reinquiry transaksi ?",
            events: "reinquiry"
        }
    },
    methods: {
        doReinquiry() {
            this.$progress.show(true);
            this.$http.post("api/transaction/reinquiry", 
                {
                    requestId: this.content.requestId
                })
            .then(success => {
                this.$message.success("Data berhasil di reinquiry");
                this.$emit("reset");
            }, err => {
                this.$message.error(err.response.data.message);
            }).finally(() => this.$progress.show(false));
        }
    },
};
</script>